import { produce } from 'immer';
import { UnknownAction } from 'redux';

import { ELEMENT_CREATE, ELEMENT_DELETE } from '../../../common/elements/elementConstants';
import { ELEMENTS_LOAD } from '../../../common/elements/elementsConstants';
import {
    ElementCreateAction,
    ElementDeleteAction,
    ElementsLoadAction,
} from '../../../common/elements/elementActionTypes';

export type DeletedElementsState = Record<string, true>;

const initialState: DeletedElementsState = {};

const getLoadedElementIds = (elements: ElementsLoadAction['elements'] = {}): string[] =>
    Object.entries(elements).map(([elementId, element]) => element.id || element._id || elementId);

const updateDeletedElementsFromLoadAction = (state: DeletedElementsState, action: ElementsLoadAction) =>
    produce(state, (draft) => {
        action.deletedElementIds?.forEach((elementId) => {
            draft[elementId] = true;
        });

        getLoadedElementIds(action.elements).forEach((elementId) => {
            delete draft[elementId];
        });
    });

/**
 * Tracks element IDs that have been deleted during the current client session.
 */
const deletedElementsReducer = (
    state: DeletedElementsState = initialState,
    action: UnknownAction,
): DeletedElementsState => {
    switch (action.type) {
        case ELEMENT_DELETE:
            return { ...state, [(action as ElementDeleteAction).id]: true };
        case ELEMENT_CREATE:
            return produce(state, (draft) => {
                delete draft[(action as ElementCreateAction).id];
            });
        case ELEMENTS_LOAD:
            return updateDeletedElementsFromLoadAction(state, action as ElementsLoadAction);
        default:
            return state;
    }
};

export default deletedElementsReducer;
